module.exports = __webpack_public_path__ + "media/ubud/temple-7c13436a.jpg";